import { RecommendedAsins } from './recommended-asins';

export { RecommendedAsins };
